import { createContext, useContext, useState, useEffect } from 'react';
const AppContext = createContext(null);
export function AppProvider({ children }) {
  const [appConfig] = useState({
    appName:    import.meta.env.REACT_APP_APP_NAME || 'PerkVora',
    brandColor: import.meta.env.REACT_APP_BRAND_COLOR || '#6B2FD9',
  });
  useEffect(() => {
    document.documentElement.style.setProperty('--brand-color', appConfig.brandColor);
  }, [appConfig.brandColor]);
  return <AppContext.Provider value={{ appConfig }}>{children}</AppContext.Provider>;
}
export const useApp = () => useContext(AppContext);
